const extractFromUrl = urlString => {
  try {
    const { searchParams } = new URL(urlString)
    return {
      utm_source: searchParams.get('c_src') || searchParams.get('utm_source'),
      utm_campaign: searchParams.get('c_src2') || searchParams.get('utm_campaign'),
    }
  } catch {
    return {}
  }
}

const extractUtmParams = embeddedOn => {
  const page = extractFromUrl(location.href)

  const embedded =
    embeddedOn && (!page.utm_source || !page.utm_campaign)
      ? extractFromUrl(embeddedOn)
      : {}

  return {
    utm_source: page.utm_source || embedded.utm_source || undefined,
    utm_campaign: page.utm_campaign || embedded.utm_campaign || undefined,
  }
}

export default extractUtmParams
